import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const Comoros: Country = {
    identifier: "Comoros",
    name: "Comoros",
    countryCode: "KM",
    group: CountryGroup.AFRICA,
    isUNMember: true,
    flag: "🇰🇲",
    svgPath: "m 596.88175,496.3434 -0.053,0.038 -0.256,-0.163 -0.146,-0.038 -0.215,-0.263 0.083,-0.91 0.069,-0.117 0.052,-0.047 0.119,-0.017 0.145,0.114 -0.038,0.585 0.191,0.394 0.123,0.313 -0.074,0.111 z m 2.836,0.514 0.141,0.394 -10e-4,0.297 -0.06,0.094 -0.126,-0.062 -0.232,-0.236 -0.441,-0.23 0.203,-0.019 0.118,0.023 0.125,-0.021 0.078,-0.13 0.016,-0.077 0.11,-0.062 0.069,0.029 z m -1.93,0.643 0.197,0.175 -0.548,-0.072 -0.086,-0.158 -0.004,-0.116 0.205,0.025 0.236,0.146 z",
}
